import React, { useReducer } from "react";
import AuthContext from "./authContext";

import authReducer from "./authReducer";
import {
  appAuth,
  authObject,
  appFirestore,
  appStorage,
  timestamp,
} from "../../firebase/config";
import {
  REGISTER_FAIL,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  CLEAR_ERRORS,
  AUTH_ERROR,
  USER_LOADED,
  ADD_ERROR,
} from "../types";

const AuthState = (props) => {
  const initialState = {
    isAuthenticated: null,
    currentUser: null,
    loading: true,
    errors: null,
  };
  const [state, dispatch] = useReducer(authReducer, initialState);

  //Load currentUser
  const loadUser = () => {
    appAuth.onAuthStateChanged(async (user) => {
      if (user) {
        let userRef = appFirestore.collection("users").doc(user.uid);

        let obj = {};
        try {
          const res = await userRef.get();
          obj = res.data();
          obj.uid = user.uid;
          dispatch({ type: USER_LOADED, payload: obj });
        } catch (error) {
          console.log(error.message);
        }
      } else {
        dispatch({ type: AUTH_ERROR });
      }
    });
  };

  //register new user
  const registerUser = async (formData) => {
    try {
      const res = await appAuth.createUserWithEmailAndPassword(
        formData.email,
        formData.password
      );

      const createdAt = timestamp();
      await appFirestore.collection("users").doc(res.user.uid).set({
        displayName: formData.displayName,
        photoURL: res.user.photoURL,
        createdAt,
        bio: "",
        email: formData.email,
        mobno: "",
        providerId: res.user.providerData[0].providerId,
        skills: [],
      });

      loadUser();
    } catch (error) {
      console.log(error.code, error.message);
      dispatch({ type: REGISTER_FAIL, payload: error.message });
    }
  };

  //Login user
  const loginUser = async (formData) => {
    try {
      await appAuth.signInWithEmailAndPassword(
        formData.email,
        formData.password
      );
    } catch (error) {
      dispatch({
        type: LOGIN_FAIL,
        payload: error.message,
      });
    }
  };

  //add error
  const addError = (err) => {
    dispatch({ type: ADD_ERROR, payload: err });
  };

  //Remove errors
  const removeErrors = () => {
    dispatch({ type: CLEAR_ERRORS });
  };

  //Logout
  const logout = async () => {
    try {
      await appAuth.signOut();

      dispatch({
        type: LOGOUT,
      });
    } catch (error) {
      dispatch({
        type: LOGIN_FAIL,
        payload: error.message,
      });
    }
  };

  //google login
  const googleLogin = () => {
    var provider = new authObject.GoogleAuthProvider();
    appAuth
      .signInWithPopup(provider)
      .then(async function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        var user = result.user;

        if (user.metadata.creationTime === user.metadata.lastSignInTime) {
          const createdAt = timestamp();
          await appFirestore.collection("users").doc(user.uid).set({
            displayName: user.displayName,
            photoURL: user.photoURL,
            createdAt,
            bio: "",
            email: user.email,
            mobno: "",
            providerId: user.providerData[0].providerId,
            skills: [],
          });
        }

        dispatch({
          type: LOGIN_SUCCESS,
          payload: { token: token, currentUser: user },
        });
      })
      .catch(function (error) {
        console.log(error.message);
      });
  };

  //add user info
  const updateUserInfo = async (info) => {
    var user = appAuth.currentUser;

    if (user && user.photoURL && state.currentUser.photoURL !== info.photoURL) {
      var desertRef = appStorage.ref().child(user.photoURL);
      desertRef
        .delete()
        .then(function () {
          // File deleted successfully
        })
        .catch(function (error) {
          //  an error occurred!
        });
    }
    user.updateProfile({ photoURL: info.filepath });
    delete info.filepath;
    try {
      await appFirestore
        .collection("users")
        .doc(state.currentUser.uid)
        .update(info);
      loadUser();
    } catch (error) {
      console.log(error.message);
    }
  };

  //change password
  const changePassword = (newPass) => {
    const user = appAuth.currentUser;
    user
      .updatePassword(newPass)
      .then(function () {
        addError("Password successfully changed");
      })
      .catch(function (error) {
        addError(error.message);
      });
  };
  const resetPassword = (emailAddress) => {
    appAuth
      .sendPasswordResetEmail(emailAddress)
      .then(function () {
        addError("Please check your email address");
      })
      .catch(function (error) {
        addError(error.message);
      });
  };
  const reAuthenticate = async (pass) => {
    const user = appAuth.currentUser;
    try {
      await appAuth.signInWithEmailAndPassword(user.email, pass);

      return "yes";
    } catch (error) {
      addError(error.message);
      console.log(error.message);
      return "no";
    }
  };

  //add comment
  const addComment = async (info) => {
    try {
      await appFirestore.collection("usercomments").add(info);
      addError("Successfully sent");
    } catch (error) {
      console.log(error.message);
      addError("There was something wrong, please try again later");
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: state.isAuthenticated,
        currentUser: state.currentUser,
        loading: state.loading,
        errors: state.errors,
        removeErrors,
        addComment,
        changePassword,
        registerUser,
        loadUser,
        reAuthenticate,
        resetPassword,
        addError,
        loginUser,
        updateUserInfo,
        logout,
        googleLogin,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
